import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { R, ft, shadow, btnAccent } from '../lib/ui';
import { useDialog } from '../components/DialogHost';

export function ForceChange() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const qc = useQueryClient();
  const { alert } = useDialog();

  const change = useMutation({
    mutationFn: () => api.changeCredentials({
      newLogin: login.trim() || undefined,
      newPassword: password
    }),
    onSuccess: () => {
      alert({
        title: 'Успешно',
        body: 'Данные изменены. Добро пожаловать!',
      });
      // Force reload to bypass mustChangePassword flag
      qc.invalidateQueries({ queryKey: ['me'] });
    },
    onError: (e: any) => {
      alert({
        title: 'Ошибка',
        body: e.message || 'Не удалось сменить данные',
      });
    }
  });

  return (
    <div
      style={{
        display: 'grid',
        placeItems: 'center',
        height: '100dvh',
        width: '100vw',
        background: R.bgSubtle,
        color: R.text,
        fontSize: 14,
        padding: 20,
      }}
    >
      <div
        style={{
          background: R.bg,
          padding: 30,
          border: ft.edge,
          boxShadow: shadow.panel,
          width: '100%',
          maxWidth: 360,
          display: 'flex',
          flexDirection: 'column',
          gap: 20,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: 800, fontSize: 18, color: R.text, marginBottom: 8 }}>Смена данных</div>
          <div style={{ fontSize: 13, color: R.textMuted }}>
            Администратор требует, чтобы вы изменили пароль при первом входе. Вы также можете сменить логин.
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: R.textMuted, textTransform: 'uppercase' }}>
              Новый логин (необязательно)
            </span>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder="Оставьте пустым, чтобы не менять"
              style={{
                background: R.bgSubtle,
                border: ft.edge,
                color: R.text,
                padding: '8px 12px',
                outline: 'none',
                width: '100%',
              }}
            />
          </label>

          <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: R.textMuted, textTransform: 'uppercase' }}>
              Новый пароль (обязательно)
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Минимум 5 символов"
              style={{
                background: R.bgSubtle,
                border: ft.edge,
                color: R.text,
                padding: '8px 12px',
                outline: 'none',
                width: '100%',
              }}
            />
          </label>
        </div>

        <button
          onClick={() => change.mutate()}
          disabled={password.length < 5 || change.isPending}
          style={{ ...btnAccent, justifyContent: 'center' }}
        >
          {change.isPending ? 'Сохраняем...' : 'Сохранить и войти'}
        </button>
      </div>
    </div>
  );
}
